import { SearchX } from 'lucide-react';
import { Brand } from './components/Brand';
import { ManualCopyDialog } from './components/ManualCopyDialog';
import { PendingRecordingsDialog } from './components/PendingRecordingsDialog';
import { Button, Toasts } from './components/ui';
import { HomePage } from './home/HomePage';
import { navigate, useRoute } from './lib/router';
import { MeetingPage } from './meeting-ui/MeetingPage';

export function App() {
  const route = useRoute();
  return (
    <>
      {route.name === 'home' && <HomePage />}
      {route.name === 'meeting' && <MeetingPage key={route.id} id={route.id} passcode={route.passcode} />}
      {route.name === 'not-found' && (
        <div className="center-screen">
          <div className="center-brand">
            <Brand />
          </div>
          <div className="center-card">
            <SearchX size={40} />
            <h1>Página no encontrada</h1>
            <Button variant="primary" onClick={() => navigate('/')}>
              Ir al inicio
            </Button>
          </div>
        </div>
      )}
      <ManualCopyDialog />
      <PendingRecordingsDialog />
      <Toasts />
    </>
  );
}
